/* eslint-disable */
import Vue from "vue";
import { Profile } from "./Profile";

export default abstract class SuperView extends Vue {
  messages: unknown;

  lang = "fr";

  get profile() {
    return this.$store.getters.profile as Profile;
  }

  toLang(key: string, ...args: string[]): string {
    return this.getI18n(key, this.messages, this.lang, args);
  }

  format(s: string, ...args: string[]): string {
    for (const x in args) s = s.replace(`{${x}}`, args[x]);

    return s;
  }

  getI18n(
    key: string,
    messages: any,
    lang: string,
    args: string[]
  ): string {
    const m = messages[lang][key] as string;

    return m ? (args.length == 0 ? m : this.format(m, ...args)) : key;
  }
}
